import InvoicePaymentsLayout from './InvoicePaymentsLayout';

export default InvoicePaymentsLayout;
